import React from 'react';
import styled from 'styled-components';

interface FadeProps {
  visible: boolean;
  timeout?: number;
  children: React.ReactElement;
}

interface FadeWrapperProps {
  $visible: boolean;
  $timeout: number;
}

const FadeWrapper = styled.div<FadeWrapperProps>`
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity ${({ $timeout }) => $timeout}ms ease-in-out;
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;

const Fade = ({ visible, timeout = 300, children }: FadeProps): JSX.Element => {
  return (
    <FadeWrapper
      $visible={visible}
      $timeout={timeout}
      as={children.type as any}
      {...children.props}
    />
  );
};

export default Fade;
